export default function StatusBadge({ type, children, onClick }) {
  const baseClasses = "px-3 py-1  text-sm font-medium flex items-center justify-center whitespace-nowrap  min-w-[80px]"

  switch (type) {
    case "confirm":
      return (
        <button className={`${baseClasses} bg-purple-500 rounded-full hover:bg-purple-600 text-white`} onClick={onClick}>
          {children}
        </button>
      )
    case "active":
      return <div className={`${baseClasses} bg-green-500 text-white`}>{children}</div>
    case "invited":
      return <div className={`${baseClasses} bg-orange-500 text-white`}>{children}</div>
      }
}
